import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { Modal } from "semantic-ui-react";

import { MainLayout, MobileOnly, Responsive } from "../../../layout";
import { ANSWERS } from "../../../util/answers";
import { getEmail, getPhoneNumber, PIN_TYPE, QUESTION_RESULT_STATUS } from "../../../util/common";
import { CUSTOMER_COMMUNICATION_STATUSES } from "../../../util/communication_statuses";

import { ErrorModal, Header, NavigationButtons, Remarks, SideMenu, SuccessMsg, Support, TyresOverviewV2 } from "../components";
import { filterApprovedInterventions, filterPendingInterventions } from "./components/ScheduledServices";

import { Order, PopupMessage, ReplacementItems, ScheduledServices } from "./components";
import { SCREENS } from "./util/screens";

import Service from "./service";

import "./index.scss";

class DiagnoseOverview extends React.Component {
  constructor(props) {
    super(props);

    const { communication } = this.props;

    const agreements = communication.agreements
      .filter(a => a.visible_customcom)
      .map(a => {
        if (communication.status < CUSTOMER_COMMUNICATION_STATUSES.DIAGNOSE_OVERVIEW_ANSWERED) a.accepted = false;

        return a;
      });

    let previousRemarks = communication.diagnose_overview_remarks;
    previousRemarks.forEach(r => {
      if (!Array.isArray(r.attachments)) r.attachments = [];

      r.attachments &&
        r.attachments.forEach(a => {
          a.name = a.name.substr(-9);
        });
    });

    let remarks = [];
    if (communication.status < CUSTOMER_COMMUNICATION_STATUSES.DIAGNOSE_OVERVIEW_ANSWERED && this.props.settings.diagnose_overview_remarks_enabled)
      remarks.push({ title: "", description: "", attachments: [] });

    const replacementItems = communication.car?.tyres?.filter(t => t.replacements?.length) ?? [];

    this.state = {
      defaultScreen: communication.status !== CUSTOMER_COMMUNICATION_STATUSES.DIAGNOSE_OVERVIEW_ANSWERED ? SCREENS.FIRST_SCREEN : SCREENS.LAST_SCREEN,
      screenBeforeSupport: null,
      readOnly: communication.status >= CUSTOMER_COMMUNICATION_STATUSES.DIAGNOSE_OVERVIEW_ANSWERED || communication.is_receptionist,
      originalCorrectEmail: communication.correct_email || getEmail(communication),
      correctEmail: communication.correct_email || getEmail(communication),
      originalCorrectPhone: communication.correct_phone || getPhoneNumber(communication),
      correctPhone: communication.correct_phone || getPhoneNumber(communication),
      communication_status: communication.status,
      approvedInterventions: filterApprovedInterventions(communication.appointment.interventions),
      pendingInterventions: filterPendingInterventions(communication.appointment.interventions),
      customerName: "",
      previousRemarks,
      remarks,
      approvedMandatoryAgreements: agreements.length === 0 || !agreements.some(a => !a.optional_customcom && !a.accepted),
      agreements,
      visibleConfirmPhoneMessage: false,
      popupIsOpen: true,
      highlightInterventions: false,
      highlightReplacementItems: false,
      showAgreementError: false,
      showCustomerNameRequiredError: false,
      showMaintenanceModal: false,
      showErrorModal: false,
      replacementItems,
    };
  }

  componentDidUpdate(_, prevState) {
    if (prevState.highlightInterventions !== this.state.highlightInterventions || prevState.highlightReplacementItems !== this.state.highlightReplacementItems) {
      const interventions = document.getElementsByClassName("scheduled-services-item highlight");
      const replacementItems = document.getElementsByClassName("replacement-item-row highlight");

      if (interventions?.length > 0) window.scrollTo({ behavior: "smooth", top: interventions[0].getBoundingClientRect().top });
      else if (replacementItems?.length > 0) window.scrollTo({ behavior: "smooth", top: replacementItems[0].getBoundingClientRect().top });
    }
  }

  displayMaintenanceModal = () => this.setState({ showMaintenanceModal: true });

  getCurrentScreen = () => {
    let { screen } = this.props;
    if (screen) {
      screen = parseInt(screen);
      if (screen === SCREENS.SUPPORT || (screen >= SCREENS.FIRST_SCREEN && screen <= SCREENS.LAST_SCREEN)) {
        return screen;
      }
    }

    return this.state.defaultScreen;
  };

  handleGoToScreen = currentScreen => {
    if (!currentScreen || currentScreen < SCREENS.FIRST_SCREEN || currentScreen > SCREENS.LAST_SCREEN) currentScreen = this.state.defaultScreen;

    const hash = this.props.location.hash;

    if (currentScreen === SCREENS.LAST_SCREEN) {
      this.props.history.replace("", null);
    }

    this.props.history.push("/" + currentScreen + hash);

    window.scrollTo(0, 0);
  };

  handleGoToNextScreen = () => {
    const { remarks, previousRemarks } = this.state;
    const { settings } = this.props;
    const currentScreen = this.getCurrentScreen();
    let shift = 1;

    if ((currentScreen === SCREENS.SCHEDULED_SERVICES || currentScreen === SCREENS.ORDER) && !this.allowedToOrder()) return;

    if (currentScreen + shift === SCREENS.REMARKS && (!settings.diagnose_overview_remarks_enabled || remarks.length + previousRemarks.length < 1)) shift++;

    this.handleGoToScreen(currentScreen + shift);
  };

  handleGoToPreviousScreen = () => {
    const { remarks, previousRemarks } = this.state;
    const { settings } = this.props;
    const currentScreen = this.getCurrentScreen();
    let shift = 1;

    if (currentScreen - shift === SCREENS.REMARKS && (!settings.diagnose_overview_remarks_enabled || remarks.length + previousRemarks.length < 1)) shift++;

    this.handleGoToScreen(currentScreen - shift);
  };

  handleGoToSupportScreen = () => {
    this.setState({ screenBeforeSupport: this.getCurrentScreen() });
    this.props.history.push("/" + SCREENS.SUPPORT + this.props.location.hash);
    window.scrollTo(0, 0);
  };

  handleGoBackFromSupportScreen = () => {
    this.handleGoToScreen(this.state.screenBeforeSupport);
  };

  handleGoToSuccessScreen = () => {
    this.setState({ communication_status: CUSTOMER_COMMUNICATION_STATUSES.DIAGNOSE_OVERVIEW_ANSWERED, readOnly: true, defaultScreen: SCREENS.LAST_SCREEN });
    this.handleGoToScreen(SCREENS.THANK_YOU);
  };

  updateCorrectPhone = correctPhone => {
    this.setState({ correctPhone });
  };

  addNewRemark = () => {
    let { remarks } = this.state;

    remarks = remarks.filter(r => r.title || r.description || r.attachments.length > 0);
    remarks.push({ title: "", description: "", attachments: [] });

    this.setState({ remarks: [...remarks] });
  };

  updateRemarks = remarks => {
    this.setState({ remarks: [...remarks] });
  };

  handleAgreed = id => {
    let { agreements } = this.state;
    let agreement = agreements.find(a => a.id === id);
    if (agreement) {
      agreement.accepted = !agreement.accepted;
      this.setState({ agreements: [...agreements], approvedMandatoryAgreements: !agreements.some(a => !a.optional_customcom && !a.accepted) });
    }
  };

  handleCustomerName = customerName => {
    this.setState({ customerName });
  };

  handleShowCustomerNameRequiredError = showCustomerNameRequiredError => {
    this.setState({ showCustomerNameRequiredError });
  };

  allowedToOrder = () => this.allowedToOrderReplacementTyres() && this.allowedToOrderInterventions();

  allowedToOrderReplacementTyres = () => {
    const { replacementItems, readOnly } = this.state;

    if (readOnly) return true;

    let highlightReplacementItems = false;

    const pendingCriticalReplacementItems = replacementItems.some(
      t => t.question_result_status === QUESTION_RESULT_STATUS.NECESSARY && t.replacements.some(r => r.communication_result_status === ANSWERS.NOT_ANSWERED)
    );

    const pendingAdvisedReplacementItems =
      !this.props.settings.skip_optional_items &&
      replacementItems.some(
        t => t.question_result_status === QUESTION_RESULT_STATUS.ADVISED && t.replacements.some(r => r.communication_result_status === ANSWERS.NOT_ANSWERED)
      );

    const pendingWithoutStatusReplacementItems =
      !this.props.settings.skip_without_status_items &&
      replacementItems.some(t => t.question_result_status === null && t.replacements.some(r => r.communication_result_status === ANSWERS.NOT_ANSWERED));

    if (pendingWithoutStatusReplacementItems || pendingAdvisedReplacementItems || pendingCriticalReplacementItems) highlightReplacementItems = true;

    this.setState({ highlightReplacementItems });

    return !highlightReplacementItems;
  };

  allowedToOrderInterventions = () => {
    const { pendingInterventions, readOnly } = this.state;
    const { settings } = this.props;

    if (readOnly) return true;

    const interventionQuestionResultStatuses = [
      QUESTION_RESULT_STATUS.NECESSARY,
      ...(!settings.skip_optional_items ? [QUESTION_RESULT_STATUS.ADVISED] : []),
      ...(!settings.skip_without_status_items ? [undefined] : []),
    ];

    const highlightInterventions = pendingInterventions.some(
      i => i.communication_result_status === ANSWERS.NOT_ANSWERED && interventionQuestionResultStatuses.includes(i.question_result_status)
    );

    this.setState({ highlightInterventions });

    return !highlightInterventions;
  };

  requiresCustomerAction = () => {
    const { pendingInterventions, replacementItems } = this.state;

    return pendingInterventions.length > 0 || replacementItems.length > 0;
  };

  handleSendAnswer = () => {
    let {
      remarks,
      originalCorrectPhone,
      originalCorrectEmail,
      correctEmail,
      correctPhone,
      customerName,
      pendingInterventions,
      agreements,
      replacementItems,
    } = this.state;

    const { cannot_decline_warranty_types } = this.props.settings;

    const requiresCustomerAction = this.requiresCustomerAction();
    let filledRemarks = remarks.filter(r => !r.readOnly && (r.title || r.description || r.attachments.length > 0));
    let email = correctEmail === originalCorrectEmail ? "" : correctEmail;
    let phone = correctPhone === originalCorrectPhone ? "" : correctPhone;

    return Service.sendAnswer({
      customer_key: this.props.routeKey,
      // WTF is this ?! we silently change the answer to add to cart ?!
      interventions: pendingInterventions.map(pi =>
        pi.pin_type_id === PIN_TYPE.WARRANTY && cannot_decline_warranty_types ? { ...pi, communication_result_status: ANSWERS.ADD_TO_CART } : pi
      ),
      replacements: replacementItems.flatMap(ri => ri.replacements ?? []),
      remarks: filledRemarks,
      agreement_ids: requiresCustomerAction ? agreements.filter(a => a.accepted).map(a => a.customer_communication_agreement_id) : [],
      correct_phone: phone,
      correct_email: email,
      customer_name: requiresCustomerAction ? customerName : "",
    });
  };

  handleAskForPhoneOrSendAnswer = () => {
    const { pendingInterventions, replacementItems } = this.state;

    if (
      pendingInterventions.some(i => i.communication_result_status === ANSWERS.CONTACT_ME) ||
      replacementItems.some(ri => ri.replacements.some(r => r.selected && r.communication_result_status === ANSWERS.CONTACT_ME))
    ) {
      this.setState({ visibleConfirmPhoneMessage: true, popupIsOpen: true });
      return null;
    }

    return this.handleSendAnswer();
  };

  handleUpdatePendingInterventions = pendingInterventions => {
    this.setState({ pendingInterventions });
  };

  handleOnClosePopup = props => {
    this.setState({ popupIsOpen: false });
    if (props?.goToScreen) this.handleGoToScreen(props.goToScreen);
  };

  updateReplacementItems = replacementItems => {
    this.setState({ replacementItems });
  };

  renderPopups = () => {
    const currentScreen = this.getCurrentScreen();
    const { correctPhone, visibleConfirmPhoneMessage, communication_status, popupIsOpen, showMaintenanceModal, showErrorModal } = this.state;
    const { communication, settings, routeKey, t } = this.props;

    if (showMaintenanceModal)
      return (
        <Modal size="small" open={true} closeOnDimmerClick={false}>
          <Modal.Content>
            <div style={{ textAlign: "center", fontSize: "18px" }}>
              {t("cc_maintenance_message").message || "Sorry, we're down for scheduled maintenance, please try again later"}
            </div>
          </Modal.Content>
        </Modal>
      );

    if (communication_status < CUSTOMER_COMMUNICATION_STATUSES.DIAGNOSE_OVERVIEW_ANSWERED) {
      if (showErrorModal)
        return (
          <ErrorModal
            isOpen={true}
            onClose={() => this.handleShowErrorModal(false)}
            message={t("cc_error_please_refresh").message || "Error please refresh"}
            onReload={() => window.location.reload(`/${routeKey}`)}
          />
        );

      if (visibleConfirmPhoneMessage) {
        return (
          <PopupMessage
            isOpen={popupIsOpen}
            onClose={this.handleOnClosePopup}
            communication={communication}
            settings={settings}
            type="confirm_phone"
            correctPhone={correctPhone}
            updateCorrectPhone={this.updateCorrectPhone}
            onSendAnswer={this.handleSendAnswer}
            onGoToSuccessScreen={this.handleGoToSuccessScreen}
            onShowErrorModal={this.handleShowErrorModal}
            showMaintenanceModal={this.displayMaintenanceModal}
          />
        );
      }

      return <PopupMessage isOpen={popupIsOpen} onClose={this.handleOnClosePopup} communication={communication} settings={settings} type="welcome" />;
    } else if (communication_status === CUSTOMER_COMMUNICATION_STATUSES.DIAGNOSE_OVERVIEW_ANSWERED && currentScreen !== SCREENS.THANK_YOU) {
      return <SuccessMsg isOpen={popupIsOpen} onClose={this.handleOnClosePopup} communication={communication} settings={settings} />;
    } else if (communication_status >= CUSTOMER_COMMUNICATION_STATUSES.DIAGNOSE_OVERVIEW_CLOSED) {
      return (
        <PopupMessage
          isOpen={popupIsOpen}
          onClose={this.handleOnClosePopup}
          communication={communication}
          settings={settings}
          type="closed"
          hideCloseButton={!settings.enable_closing_pop_up_on_cc}
        />
      );
    }

    return null;
  };

  renderMainColumn = () => {
    const { communication, settings, routeKey, t } = this.props;
    const {
      remarks,
      approvedInterventions,
      pendingInterventions,
      highlightInterventions,
      correctEmail,
      correctPhone,
      readOnly,
      previousRemarks,
      replacementItems,
      highlightReplacementItems,
    } = this.state;
    const title = t("cc_diagnose_overview").message || "Diagnose overview";
    const currentScreen = this.getCurrentScreen();

    return (
      <Responsive showMobile={currentScreen !== SCREENS.ORDER} className="mainContent">
        {currentScreen === SCREENS.SUPPORT && <Support settings={settings} />}
        {currentScreen !== SCREENS.SUPPORT && (
          <>
            <Header
              showActionLegend
              title={title}
              communication={communication}
              settings={settings}
              showMobile={currentScreen === SCREENS.INFO}
              correctEmail={correctEmail}
              correctPhone={correctPhone}
              showFooter
            />

            <ScheduledServices
              highlightInterventions={highlightInterventions}
              pendingInterventions={pendingInterventions}
              approvedInterventions={approvedInterventions}
              onUpdatePendingInterventions={this.handleUpdatePendingInterventions}
              showMobile={currentScreen === SCREENS.SCHEDULED_SERVICES}
              settings={settings}
              readOnly={readOnly}
            />
            <ReplacementItems
              highlightReplacementItems={highlightReplacementItems}
              items={replacementItems}
              updateItems={this.updateReplacementItems}
              readOnly={readOnly}
              settings={settings}
              showMobile={currentScreen === SCREENS.SCHEDULED_SERVICES}
            />
            {currentScreen === SCREENS.SCHEDULED_SERVICES && !pendingInterventions.length && !replacementItems.length && (
              <MobileOnly className="component-container diagnose-overview-empty-message">
                {t("cc_nothing_extra_to_fix").message || "There is nothing extra to fix on your car."}
              </MobileOnly>
            )}
            <TyresOverviewV2 communication={communication} settings={settings} />
            {previousRemarks.length > 0 && <Remarks readOnly={true} showMobile={currentScreen === SCREENS.REMARKS} remarks={previousRemarks} />}
            {settings.diagnose_overview_remarks_enabled && (
              <Remarks
                uploadImages={Service.uploadImages}
                readOnly={readOnly}
                routeKey={routeKey}
                showMobile={currentScreen === SCREENS.REMARKS}
                remarks={remarks}
                addNewRemark={this.addNewRemark}
                updateRemarks={this.updateRemarks}
              />
            )}
            <SuccessMsg
              communication={communication}
              settings={settings}
              isOpen={currentScreen === SCREENS.THANK_YOU}
              onClose={() => this.handleOnClosePopup({ goToScreen: SCREENS.INFO })}
            />
          </>
        )}
      </Responsive>
    );
  };

  handleShowAgreementError = showAgreementError => {
    this.setState({ showAgreementError });
  };

  renderOrderColumn = side => {
    const { layout } = this.props.settings;
    if ((layout === 1 && side === "right") || (layout === 2 && side === "left")) {
      const {
        approvedInterventions,
        pendingInterventions,
        remarks,
        previousRemarks,
        readOnly,
        agreements,
        approvedMandatoryAgreements,
        showAgreementError,
        customerName,
        showCustomerNameRequiredError,
        replacementItems,
      } = this.state;
      const { communication, settings } = this.props;
      const currentScreen = this.getCurrentScreen();
      const requiresCustomerAction = this.requiresCustomerAction();

      return (
        <Responsive showMobile={currentScreen === SCREENS.ORDER}>
          <SideMenu
            communication={communication}
            settings={settings}
            supportActive={currentScreen === SCREENS.SUPPORT}
            goToSupportScreen={this.handleGoToSupportScreen}
            goBackFromSupportScreen={this.handleGoBackFromSupportScreen}
          >
            <Order
              readOnly={readOnly}
              settings={settings}
              approvedInterventions={approvedInterventions}
              pendingInterventions={pendingInterventions}
              replacementItems={replacementItems}
              remarks={previousRemarks.concat(...remarks)}
              agreements={requiresCustomerAction ? agreements : null}
              approved={!requiresCustomerAction || approvedMandatoryAgreements}
              onAgreed={this.handleAgreed}
              allowedToOrder={this.allowedToOrder}
              onSendAnswer={this.handleAskForPhoneOrSendAnswer}
              onGoToSuccessScreen={this.handleGoToSuccessScreen}
              showAgreementError={showAgreementError}
              onShowAgreementError={this.handleShowAgreementError}
              onCustomerNameChange={this.handleCustomerName}
              customerName={customerName}
              customerNameVisible={requiresCustomerAction && settings.diagnose_overview_name_visible}
              onShowCustomerNameRequiredError={this.handleShowCustomerNameRequiredError}
              showCustomerNameRequiredError={showCustomerNameRequiredError}
              showMaintenanceModal={this.displayMaintenanceModal}
            />
          </SideMenu>
        </Responsive>
      );
    }

    return null;
  };

  handleShowErrorModal = showErrorModal => this.setState({ showErrorModal });

  renderNavigation = () => {
    const { communication_status, approvedMandatoryAgreements, showAgreementError, customerName } = this.state;
    const { settings, t } = this.props;

    const currentScreen = this.getCurrentScreen();
    const diagnoseAnswered = communication_status >= CUSTOMER_COMMUNICATION_STATUSES.DIAGNOSE_OVERVIEW_ANSWERED;
    const requiresCustomerAction = this.requiresCustomerAction();

    return (
      <NavigationButtons
        SCREENS={SCREENS}
        answered={diagnoseAnswered}
        answerLabel={t("cc_CONFIRM").message || "CONFIRM"}
        approved={!requiresCustomerAction || approvedMandatoryAgreements}
        currentScreen={currentScreen}
        onGoToPreviousScreen={this.handleGoToPreviousScreen}
        onGoToNextScreen={this.handleGoToNextScreen}
        allowedToOrder={this.allowedToOrder}
        onSendAnswer={this.handleAskForPhoneOrSendAnswer}
        onGoToSuccessScreen={this.handleGoToSuccessScreen}
        showAgreementError={showAgreementError}
        onShowAgreementError={this.handleShowAgreementError}
        customerName={customerName}
        customerNameVisible={requiresCustomerAction && settings.diagnose_overview_name_visible}
        onShowCustomerNameRequiredError={this.handleShowCustomerNameRequiredError}
        onShowErrorModal={this.handleShowErrorModal}
        backOnly={diagnoseAnswered && currentScreen === SCREENS.ORDER}
      />
    );
  };

  render() {
    const { settings, t } = this.props;

    return (
      <MainLayout
        mobileTitle={t("cc_diagnose_overview").message || "Diagnose overview"}
        color={settings.color}
        popups={this.renderPopups()}
        leftColumn={this.renderOrderColumn("left")}
        mainColumn={this.renderMainColumn()}
        rightColumn={this.renderOrderColumn("right")}
        navigation={this.renderNavigation()}
      />
    );
  }
}

export default withRouter(withTranslation()(DiagnoseOverview));
